module.exports = __webpack_public_path__ + "static/images/monet/left_panel_new_window.png";